import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { MessageBoxType } from './../../shared/message-box/message-box.component';
import { isUndefined } from 'util';
import { LoginAndUserManagerService } from '../../api/managers/login-and-user-manager.service';
import { MessageBoxService } from './../../services/message-box.service';
import { Constants } from '../../core/constants';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.less']
})
export class ResetPasswordComponent implements OnInit {

    userPassword: string;
    userConfirmPassword: string;
    id: string;
    secret: string;

    isLoading = false;

    errorMessage;
    showResetPasswordSuccess = false;
    isResetLinkValid: boolean = false;
    passwordMsg: string;

    constructor(private router: Router,
        private loginAndUserManagerService: LoginAndUserManagerService,
        private messageBoxService: MessageBoxService) { }

    ngOnInit() {
        this.passwordMsg = Constants.Strings.PaaswordRequirementsMessage;
        this.id = (this.router.parseUrl(this.router.url)).queryParams.id;
        this.secret = encodeURIComponent((this.router.parseUrl(this.router.url)).queryParams.secret);
        this.secret = String(this.secret.replace('%', '')).toLowerCase();
        if (isUndefined(this.id) || isUndefined(this.secret)) {
            this.router.navigateByUrl('welcome');
        }
        this.validateResetLink()

    }

    validateResetLink() {
        this.isLoading = true;
        this.errorMessage = '';
        this.loginAndUserManagerService.validateResetLink(this.id, this.secret)
            .pipe(finalize(() => this.isLoading = false))
            .subscribe((response: any) => {
                if (response.Success == false && response.Message) {
                    //Link validation Success false now display error to user
                    let message = response.Message;
                    this.errorMessage = response.Message;
                    this.isResetLinkValid = false;
                    this.goToMain()
                    this.messageBoxService.displayMessageBox(message, MessageBoxType.Error);
                } else {
                    //Link validation Success now redirect user to reset
                    this.isResetLinkValid = true;
                }
            }, err => {
                // TODO: MW - Does this condition ever happen?
                this.isResetLinkValid = false;
                if (err.Message) {
                    this.errorMessage = err.Message;
                } else {
                    this.errorMessage = err;
                }
            });
    }

    goToMain() {
        this.router.navigate(['welcome']);
    }

    goToLogin() {
        this.router.navigate(['/welcome'], { queryParams: { signIn: true } });
    }

    onResetPassword(form: NgForm) {
        this.userPassword = form.value.userPassword;
        this.isLoading = true;
        this.loginAndUserManagerService.resetPassword(this.userPassword, this.id, this.secret)
            .pipe(
                finalize(() => this.isLoading = false)
            )
            .subscribe(() => {
                this.showResetPasswordSuccess = true;
            }, err => {
                // TODO: MW - Does this condition ever happen?
                if (err.status === 200) {
                    this.showResetPasswordSuccess = true;
                    return;
                }
                this.errorMessage = err.error.ModelState.Error;
            });
    }

}
